<div class="patient-app-container" *ngIf="url$ | async as url "
  [class.dialog-resize]='isResizePatientAppDialog' [class.visible-conflict]='isPatientInConflict'>
  <iframe id="inline-patient-app" class="patient-app-iframe" [src]="url"></iframe>
</div>